type SourceMap = {
  [key: string]: string[]
}

//STATE_CASELAW_SOURCES - Mapping of state names to case law jurisdiction codes.
// This is added based on the state name selected.
export const STATE_TO_STATE_COURT_MAP: SourceMap = {
  alabama: ['Ala.', 'Ala. Civ. App.', 'Ala. Crim. App.'],
  alaska: ['Alaska', 'Alaska Ct. App.'],
  arizona: ['Ariz.', 'Ariz. Ct. App.'],
  arkansas: ['Ark.', 'Ark. Ct. App.'],
  california: ['Cal.', 'Cal. Ct. App.', 'Cal. Super.'],
  colorado: ['Colo.', 'Colo. App.'],
  connecticut: ['Conn.', 'Conn. App. Ct.'],
  delaware: ['Del.', 'Del. Ch.', 'Del. Super. Ct.'],
  'district of columbia': ['D.C.'],
  florida: ['Fla.', 'Fla. Dist. Ct. App.'],
  georgia: ['Ga.', 'Ga. Ct. App.'],
  guam: ['Guam'],
  hawaii: ['Haw.', 'Haw. Ct. App.'],
  idaho: ['Idaho', 'Idaho Ct. App.'],
  illinois: ['Ill.', 'Ill. App. Ct.'],
  indiana: ['Ind.', 'Ind. App.', 'Ind. Ct. App.'],
  iowa: ['Iowa', 'Iowa Ct. App.'],
  kansas: ['Kan.', 'Kan. Ct. App.'],
  kentucky: ['Ky.', 'Ky. Ct. App.'],
  louisiana: ['La.', 'La. Ct. App.'],
  maine: ['Me.'],
  maryland: ['Md.', 'Md. Ct. Spec. App.'],
  massachusetts: ['Mass.', 'Mass. App. Ct.'],
  michigan: ['Mich.', 'Mich. Ct. App.'],
  minnesota: ['Minn.', 'Minn. Ct. App.'],
  mississippi: ['Miss.', 'Miss. Ct. App.'],
  missouri: ['Mo.', 'Mo. Ct. App.'],
  montana: ['Mont.'],
  nebraska: ['Neb.', 'Neb. Ct. App.'],
  nevada: ['Nev.'],
  'new hampshire': ['N.H.'],
  'new jersey': ['N.J.', 'N.J. Super.', 'N.J. Super. Law Div.', 'N.J. Ch.', 'N.J. Super. Ch. Div.'],
  'new mexico': ['N.M.', 'N.M. Ct. App.'],
  'new york': ['N.Y.', 'N.Y. App. Div.', 'N.Y. App. Term'],
  'north carolina': ['N.C.', 'N.C. Ct. App.'],
  'north dakota': ['N.D.', 'N.D. Ct. App.'],
  'northern mariana islands': ['N. Mar. I.'],
  ohio: ['Ohio', 'Ohio Ct. App.'],
  oklahoma: ['Okla.', 'Okla. Civ. App.', 'Okla. Crim. App.'],
  oregon: ['Or.', 'Or. Ct. App.'],
  pennsylvania: ['Pa.', 'Pa. Super. Ct.', 'Pa. Cmmw. Ct.'],
  'rhode island': ['R.I.', 'R.I. Super.'],
  'south carolina': ['S.C.', 'S.C. Ct. App.'],
  'south dakota': ['S.D.'],
  tennessee: ['Tenn.', 'Tenn. Ct. App.', 'Tenn. Crim. App.'],
  texas: ['Tex.', 'Tex. App.', 'Tex. Crim. App.', 'Tex. Civ. App.'],
  utah: ['Utah', 'Utah Ct. App.'],
  vermont: ['Vt.'],
  virginia: ['Va.', 'Va. Ct. App.'],
  washington: ['Wash.', 'Wash. Ct. App.'],
  'west virginia': ['W. Va.'],
  wisconsin: ['Wis.', 'Wis. Ct. App.'],
  wyoming: ['Wyo.'],
}

const FEDERAL_DISTRICT_KEYS_BY_STATE: SourceMap = {
  alabama: ['m.d. alabama', 'n.d. alabama', 's.d. alabama'],
  alaska: ['d. alaska'],
  arizona: ['d. arizona'],
  arkansas: ['e.d. arkansas', 'w.d. arkansas'],
  california: ['c.d. california', 'e.d. california', 'n.d. california', 's.d. california'],
  colorado: ['d. colorado'],
  connecticut: ['d. connecticut'],
  delaware: ['d. delaware'],
  'district of columbia': ['d. district of columbia'],
  florida: ['m.d. florida', 'n.d. florida', 's.d. florida'],
  georgia: ['m.d. georgia', 'n.d. georgia', 's.d. georgia'],
  guam: ['d. guam'],
  hawaii: ['d. hawaii'],
  idaho: ['d. idaho'],
  illinois: ['c.d. illinois', 'n.d. illinois', 's.d. illinois'],
  indiana: ['n.d. indiana', 's.d. indiana'],
  iowa: ['n.d. iowa', 's.d. iowa'],
  kansas: ['d. kansas'],
  kentucky: ['e.d. kentucky', 'w.d. kentucky'],
  louisiana: ['e.d. louisiana', 'm.d. louisiana', 'w.d. louisiana'],
  maine: ['d. maine'],
  maryland: ['d. maryland'],
  massachusetts: ['d. massachusetts'],
  michigan: ['e.d. michigan', 'w.d. michigan'],
  minnesota: ['d. minnesota'],
  mississippi: ['n.d. mississippi', 's.d. mississippi'],
  missouri: ['e.d. missouri', 'w.d. missouri'],
  montana: ['d. montana'],
  nebraska: ['d. nebraska'],
  nevada: ['d. nevada'],
  'new hampshire': ['d. new hampshire'],
  'new jersey': ['d. new jersey'],
  'new mexico': ['d. new mexico'],
  'new york': ['e.d. new york', 'n.d. new york', 's.d. new york', 'w.d. new york'],
  'north carolina': ['e.d. north carolina', 'm.d. north carolina', 'w.d. north carolina'],
  'north dakota': ['d. north dakota'],
  'northern mariana islands': [],
  ohio: ['n.d. ohio', 's.d. ohio'],
  oklahoma: ['e.d. oklahoma', 'n.d. oklahoma', 'w.d. oklahoma'],
  oregon: ['d. oregon'],
  pennsylvania: ['e.d. pennsylvania', 'm.d. pennsylvania', 'w.d. pennsylvania'],
  'puerto rico': ['d. puerto rico'],
  'rhode island': ['d. rhode island'],
  'south carolina': ['d. south carolina'],
  'south dakota': ['d. south dakota'],
  tennessee: ['e.d. tennessee', 'm.d. tennessee', 'w.d. tennessee'],
  texas: ['e.d. texas', 'n.d. texas', 's.d. texas', 'w.d. texas'],
  utah: ['d. utah'],
  vermont: ['d. vermont'],
  virginia: ['e.d. virginia', 'w.d. virginia'],
  'virgin islands': ['d. virgin islands'],
  washington: ['e.d. washington', 'w.d. washington'],
  'west virginia': ['n.d. west virginia', 's.d. west virginia'],
  wisconsin: ['e.d. wisconsin', 'w.d. wisconsin'],
  wyoming: ['d. wyoming'],
}

// STATE_LRR_SOURCES_MAP - Mapping of state names to LRR jurisdiction codes.
// This is added based on the state name selected.
export const STATE_LRR_SOURCES_MAP: SourceMap = {
  alabama: ['alabama-administrative-code', 'alabama-constitution', 'alabama-court-rules', 'code-of-alabama'],
  alaska: ['alaska-administrative-code', 'alaska-constitution', 'alaska-court-rules', 'alaska-statutes'],
  arizona: ['arizona-administrative-code', 'arizona-constitution', 'arizona-court-rules', 'arizona-revised-statutes'],
  arkansas: ['arkansas-administrative-code', 'arkansas-code-of-1987', 'arkansas-constitution', 'arkansas-court-rules'],
  california: ['california-code-of-regulations', 'california-codes', 'california-constitution', 'ca-rules-of-court'],
  colorado: ['colorado-administrative-code', 'colorado-constitution', 'colorado-court-rules', 'colorado-revised-statutes'],
  connecticut: ['connecticut-administrative-code', 'connecticut-constitution', 'connecticut-court-rules', 'general-statutes-of-connecticut'],
  delaware: ['delaware-administrative-code', 'delaware-code', 'delaware-constitution', 'delaware-court-rules'],
  'district of columbia': ['district-of-columbia-administrative-code', 'district-of-columbia-court-rules', 'district-of-columbia-official-code'],
  florida: ['florida-administrative-code', 'florida-constitution', 'florida-court-rules', 'florida-statutes'],
  georgia: ['code-of-georgia', 'georgia-administrative-code', 'georgia-constitution', 'georgia-court-rules'],
  guam: [],
  hawaii: ['hawaii-administrative-rules', 'hawaii-constitution', 'hawaii-court-rules', 'hawaii-revised-statutes'],
  idaho: ['idaho-administrative-code', 'idaho-code', 'idaho-constitution', 'idaho-court-rules'],
  illinois: ['illinois-administrative-code', 'illinois-compiled-statutes', 'illinois-constitution', 'illinois-court-rules'],
  indiana: ['indiana-administrative-code', 'indiana-code', 'indiana-constitution', 'indiana-court-rules'],
  iowa: ['code-of-iowa', 'iowa-administrative-code', 'iowa-constitution', 'iowa-court-rules'],
  kansas: ['kansas-administrative-code', 'kansas-constitution', 'kansas-court-rules', 'kansas-statutes'],
  kentucky: ['kentucky-administrative-regulations', 'kentucky-constitution', 'kentucky-court-rules', 'kentucky-revised-statutes'],
  louisiana: ['louisiana-administrative-code', 'louisiana-constitution', 'louisiana-court-rules', 'louisiana-revised-statutes'],
  maine: ['maine-administrative-code', 'maine-constitution', 'maine-court-rules', 'maine-statutes'],
  maryland: ['code-of-maryland', 'maryland-administrative-code', 'maryland-constitution', 'maryland-court-rules'],
  massachusetts: ['code-of-massachusetts-regulations', 'general-laws-of-massachusetts', 'massachusetts-constitution', 'massachusetts-court-rules'],
  michigan: ['michigan-administrative-code', 'michigan-compiled-laws', 'michigan-constitution', 'michigan-court-rules'],
  minnesota: ['minnesota-administrative-rules', 'minnesota-constitution', 'minnesota-court-rules', 'minnesota-statutes'],
  mississippi: ['mississippi-administrative-code', 'mississippi-code-1972', 'mississippi-constitution', 'mississippi-court-rules'],
  missouri: ['missouri-administrative-code', 'missouri-constitution', 'missouri-court-rules', 'missouri-revised-statutes'],
  montana: ['montana-administrative-code', 'montana-code', 'montana-constitution'],
  'northern mariana islands': [],
  nebraska: ['revised-statutes-of-nebraska', 'nebraska-administrative-code', 'nebraska-constitution', 'nebraska-rules'],
  nevada: ['nevada-administrative-code', 'nevada-constitution', 'nevada-court-rules', 'nevada-revised-statutes'],
  'new hampshire': ['new-hampshire-administrative-code', 'new-hampshire-constitution', 'new-hampshire-court-rules', 'new-hampshire-revised-statutes'],
  'new jersey': ['new-jersey-administrative-code', 'new-jersey-constitution', 'new-jersey-rules-of-court', 'new-jersey-statutes'],
  'new mexico': ['new-mexico-administrative-code', 'new-mexico-constitution', 'new-mexico-court-rules', 'new-mexico-statutes-1978'],
  'new york': ['consolidated-laws-of-new-york', 'new-york-codes-rules-and-regulations', 'new-york-constitution'],
  'north carolina': ['general-statutes-of-north-carolina', 'north-carolina-administrative-code', 'north-carolina-constitution', 'north-carolina-court-rules'],
  'north dakota': ['north-dakota-administrative-code', 'north-dakota-century-code', 'north-dakota-constitution', 'north-dakota-court-rules'],
  ohio: ['ohio-administrative-code', 'ohio-constitution', 'ohio-court-rules', 'ohio-revised-code'],
  oklahoma: ['oklahoma-administrative-code', 'oklahoma-constitution', 'oklahoma-statutes'],
  oregon: ['oregon-administrative-code', 'oregon-constitution', 'oregon-court-rules', 'oregon-revised-statutes'],
  pennsylvania: ['pennsylvania-code-rules-and-regulations', 'pennsylvania-constitution', 'pennsylvania-local-court-rules', 'pennsylvania-statutes'],
  'puerto rico': ['laws-of-puerto-rico'],
  'rhode island': ['general-laws-of-rhode-island', 'rhode-island-administrative-code', 'rhode-island-constitution', 'rhode-island-court-rules'],
  'south carolina': ['code-of-laws-of-south-carolina-1976', 'south-carolina-code-of-regulations', 'south-carolina-constitution', 'south-carolina-court-rules'],
  'south dakota': ['south-dakota-administrative-rules', 'south-dakota-codified-laws', 'south-dakota-constitution'],
  tennessee: ['tennessee-administrative-code', 'tennessee-code', 'tennessee-constitution', 'tennessee-court-rules'],
  texas: ['texas-administrative-code', 'texas-codes', 'texas-constitution', 'texas-court-rules'],
  utah: ['utah-administrative-code', 'utah-code', 'utah-constitution', 'utah-court-rules'],
  vermont: ['vermont-administrative-code', 'vermont-constitution', 'vermont-court-rules', 'vermont-statutes'],
  virginia: ['code-of-virginia', 'virginia-administrative-code', 'virginia-constitution', 'virginia-court-rules'],
  'virgin islands': [],
  washington: ['revised-code-of-washington', 'washington-administrative-code', 'washington-constitution', 'washington-court-rules'],
  'west virginia': ['west-virginia-administrative-code', 'west-virginia-code', 'west-virginia-constitution', 'west-virginia-court-rules'],
  wisconsin: ['wisconsin-administrative-code', 'wisconsin-constitution', 'wisconsin-statutes'],
  wyoming: ['wyoming-administrative-code', 'wyoming-constitution', 'wyoming-court-rules', 'wyoming-statutes'],
}

export const FEDERAL_DISTRICT_TO_COURTS_MAP: SourceMap = {
  'm.d. alabama': ['11th Cir.', 'M.D. Ala.', 'Bankr. M.D. Ala.'],
  'n.d. alabama': ['11th Cir.', 'N.D. Ala.', 'Bankr. N.D. Ala.'],
  's.d. alabama': ['11th Cir.', 'S.D. Ala.', 'Bankr. S.D. Ala.'],
  'd. alaska': ['9th Cir.', 'D. Alaska', 'Bankr. D. Alaska', 'B.A.P. 9th Cir.'],
  'd. arizona': ['9th Cir.', 'D. Ariz.', 'Bankr. D. Ariz.', 'B.A.P. 9th Cir.'],
  'e.d. arkansas': ['8th Cir.', 'E.D. Ark.', 'Bankr. E.D. Ark.', 'B.A.P. 8th Cir.'],
  'w.d. arkansas': ['8th Cir.', 'W.D. Ark.', 'Bankr. W.D. Ark.', 'B.A.P. 8th Cir.'],
  'c.d. california': ['9th Cir.', 'C.D. Cal.', 'Bankr. C.D. Cal.', 'B.A.P. 9th Cir.'],
  'e.d. california': ['9th Cir.', 'E.D. Cal.', 'Bankr. E.D. Cal.', 'B.A.P. 9th Cir.'],
  'n.d. california': ['9th Cir.', 'N.D. Cal.', 'Bankr. N.D. Cal.', 'B.A.P. 9th Cir.'],
  's.d. california': ['9th Cir.', 'S.D. Cal.', 'Bankr. S.D. Cal.', 'B.A.P. 9th Cir.'],
  'd. colorado': ['10th Cir.', 'D. Colo.', 'Bankr. D. Colo.', 'B.A.P. 10th Cir.'],
  'd. connecticut': ['2d Cir.', 'D. Conn.', 'Bankr. D. Conn.', 'B.A.P. 2d Cir.'],
  'd. delaware': ['3d Cir.', 'D. Del.', 'Bankr. D. Del.'],
  'd. district of columbia': ['D.C. Cir.', 'D.D.C.', 'Bankr. D.D.C.'],
  'm.d. florida': ['11th Cir.', 'M.D. Fla.', 'Bankr. M.D. Fla.'],
  'n.d. florida': ['11th Cir.', 'N.D. Fla.', 'Bankr. N.D. Fla.'],
  's.d. florida': ['11th Cir.', 'S.D. Fla.', 'Bankr. S.D. Fla.'],
  'm.d. georgia': ['11th Cir.', 'M.D. Ga.', 'Bankr. M.D. Ga.'],
  'n.d. georgia': ['11th Cir.', 'N.D. Ga.', 'Bankr. N.D. Ga.'],
  's.d. georgia': ['11th Cir.', 'S.D. Ga.', 'Bankr. S.D. Ga.'],
  'd. guam': ['9th Cir.', 'D. Guam', 'Bankr. D. Guam', 'B.A.P. 9th Cir.'],
  'd. hawaii': ['9th Cir.', 'D. Haw.', 'Bankr. D. Haw.', 'B.A.P. 9th Cir.'],
  'd. idaho': ['9th Cir.', 'D. Idaho', 'Bankr. D. Idaho', 'B.A.P. 9th Cir.'],
  'c.d. illinois': ['7th Cir.', 'C.D. Ill.', 'Bankr. C.D. Ill.'],
  'n.d. illinois': ['7th Cir.', 'N.D. Ill.', 'Bankr. N.D. Ill.'],
  's.d. illinois': ['7th Cir.', 'S.D. Ill.', 'Bankr. S.D. Ill.'],
  'n.d. indiana': ['7th Cir.', 'N.D. Ind.', 'Bankr. N.D. Ind.'],
  's.d. indiana': ['7th Cir.', 'S.D. Ind.', 'Bankr. S.D. Ind.'],
  'n.d. iowa': ['8th Cir.', 'N.D. Iowa', 'Bankr. N.D. Iowa', 'B.A.P. 8th Cir.'],
  's.d. iowa': ['8th Cir.', 'S.D. Iowa', 'Bankr. S.D. Iowa', 'B.A.P. 8th Cir.'],
  'd. kansas': ['10th Cir.', 'D. Kan.', 'Bankr. D. Kan.', 'B.A.P. 10th Cir.'],
  'e.d. kentucky': ['6th Cir.', 'E.D. Ky.', 'Bankr. E.D. Ky.', 'B.A.P. 6th Cir.'],
  'w.d. kentucky': ['6th Cir.', 'W.D. Ky.', 'Bankr. W.D. Ky.', 'B.A.P. 6th Cir.'],
  'e.d. louisiana': ['5th Cir.', 'E.D. La.', 'Bankr. E.D. La.'],
  'm.d. louisiana': ['5th Cir.', 'M.D. La.', 'Bankr. M.D. La.'],
  'w.d. louisiana': ['5th Cir.', 'W.D. La.', 'Bankr. W.D. La.'],
  'd. maine': ['1st Cir.', 'D. Me.', 'Bankr. D. Me.', 'B.A.P. 1st Cir.'],
  'd. maryland': ['4th Cir.', 'D. Md.', 'Bankr. D. Md.'],
  'd. massachusetts': ['1st Cir.', 'D. Mass.', 'Bankr. D. Mass.', 'B.A.P. 1st Cir.'],
  'e.d. michigan': ['6th Cir.', 'E.D. Mich.', 'Bankr. E.D. Mich.', 'B.A.P. 6th Cir.'],
  'w.d. michigan': ['6th Cir.', 'W.D. Mich.', 'Bankr. W.D. Mich.', 'B.A.P. 6th Cir.'],
  'd. minnesota': ['8th Cir.', 'D. Minn.', 'Bankr. D. Minn.', 'B.A.P. 8th Cir.'],
  'n.d. mississippi': ['5th Cir.', 'N.D. Miss.', 'Bankr. N.D. Miss.'],
  's.d. mississippi': ['5th Cir.', 'S.D. Miss.', 'Bankr. S.D. Miss.'],
  'e.d. missouri': ['8th Cir.', 'E.D. Mo.', 'Bankr. E.D. Mo.', 'B.A.P. 8th Cir.'],
  'w.d. missouri': ['8th Cir.', 'W.D. Mo.', 'Bankr. W.D. Mo.', 'B.A.P. 8th Cir.'],
  'd. montana': ['9th Cir.', 'D. Mont.', 'Bankr. D. Mont.', 'B.A.P. 9th Cir.'],
  'd. nebraska': ['8th Cir.', 'D. Neb.', 'Bankr. D. Neb.', 'B.A.P. 8th Cir.'],
  'd. nevada': ['9th Cir.', 'D. Nev.', 'Bankr. D. Nev.', 'B.A.P. 9th Cir.'],
  'd. new hampshire': ['1st Cir.', 'D.N.H.', 'Bankr. D.N.H.', 'B.A.P. 1st Cir.'],
  'd. new jersey': ['3d Cir.', 'D.N.J.', 'Bankr. D.N.J.'],
  'd. new mexico': ['10th Cir.', 'D.N.M.', 'Bankr. D.N.M.', 'B.A.P. 10th Cir.'],
  'e.d. new york': ['2d Cir.', 'E.D.N.Y.', 'Bankr. E.D.N.Y.', 'B.A.P. 2d Cir.'],
  'n.d. new york': ['2d Cir.', 'N.D.N.Y.', 'Bankr. N.D.N.Y.', 'B.A.P. 2d Cir.'],
  's.d. new york': ['2d Cir.', 'S.D.N.Y.', 'Bankr. S.D.N.Y.', 'B.A.P. 2d Cir.'],
  'w.d. new york': ['2d Cir.', 'W.D.N.Y.', 'Bankr. W.D.N.Y.', 'B.A.P. 2d Cir.'],
  'e.d. north carolina': ['4th Cir.', 'E.D.N.C.', 'Bankr. E.D.N.C.'],
  'm.d. north carolina': ['4th Cir.', 'M.D.N.C.', 'Bankr. M.D.N.C.'],
  'w.d. north carolina': ['4th Cir.', 'W.D.N.C.', 'Bankr. W.D.N.C.'],
  'd. north dakota': ['8th Cir.', 'D.N.D.', 'Bankr. D.N.D.', 'B.A.P. 8th Cir.'],
  'n.d. ohio': ['6th Cir.', 'N.D. Ohio', 'Bankr. N.D. Ohio', 'B.A.P. 6th Cir.'],
  's.d. ohio': ['6th Cir.', 'S.D. Ohio', 'Bankr. S.D. Ohio', 'B.A.P. 6th Cir.'],
  'e.d. oklahoma': ['10th Cir.', 'E.D. Okla.', 'Bankr. E.D. Okla.', 'B.A.P. 10th Cir.'],
  'n.d. oklahoma': ['10th Cir.', 'N.D. Okla.', 'Bankr. N.D. Okla.', 'B.A.P. 10th Cir.'],
  'w.d. oklahoma': ['10th Cir.', 'W.D. Okla.', 'Bankr. W.D. Okla.', 'B.A.P. 10th Cir.'],
  'd. oregon': ['9th Cir.', 'D. Or.', 'Bankr. D. Or.'],
  'e.d. pennsylvania': ['3d Cir.', 'E.D. Pa.', 'Bankr. E.D. Pa.'],
  'm.d. pennsylvania': ['3d Cir.', 'M.D. Pa.', 'Bankr. M.D. Pa.'],
  'w.d. pennsylvania': ['3d Cir.', 'W.D. Pa.', 'Bankr. W.D. Pa.'],
  'd. puerto rico': ['1st Cir.', 'D.P.R.', 'Bankr. D.P.R.', 'B.A.P. 1st Cir.'],
  'd. rhode island': ['1st Cir.', 'D.R.I.', 'Bankr. D.R.I.', 'B.A.P. 1st Cir.'],
  'd. south carolina': ['4th Cir.', 'D.S.C.', 'Bankr. D.S.C.'],
  'd. south dakota': ['8th Cir.', 'D.S.D.', 'Bankr. D.S.D.', 'B.A.P. 8th Cir.'],
  'e.d. tennessee': ['6th Cir.', 'E.D. Tenn.', 'Bankr. E.D. Tenn.', 'B.A.P. 6th Cir.'],
  'm.d. tennessee': ['6th Cir.', 'M.D. Tenn.', 'Bankr. M.D. Tenn.', 'B.A.P. 6th Cir.'],
  'w.d. tennessee': ['6th Cir.', 'W.D. Tenn.', 'Bankr. W.D. Tenn.', 'B.A.P. 6th Cir.'],
  'e.d. texas': ['5th Cir.', 'E.D. Tex.', 'Bankr. E.D. Tex.'],
  'n.d. texas': ['5th Cir.', 'N.D. Tex.', 'Bankr. N.D. Tex.'],
  's.d. texas': ['5th Cir.', 'S.D. Tex.', 'Bankr. S.D. Tex.'],
  'w.d. texas': ['5th Cir.', 'W.D. Tex.', 'Bankr. W.D. Tex.'],
  'd. utah': ['10th Cir.', 'D. Utah', 'Bankr. D. Utah', 'B.A.P. 10th Cir.'],
  'd. vermont': ['2d Cir.', 'D. Vt.', 'Bankr. D. Vt.', 'B.A.P. 2d Cir.'],
  'd. virgin islands': ['3d Cir.', 'D.V.I.', 'Bankr. D.V.I.'],
  'e.d. virginia': ['4th Cir.', 'E.D. Va.', 'Bankr. E.D. Va.'],
  'w.d. virginia': ['4th Cir.', 'W.D. Va.', 'Bankr. W.D. Va.'],
  'e.d. washington': ['9th Cir.', 'E.D. Wash.', 'Bankr. E.D. Wash.', 'B.A.P. 9th Cir.'],
  'w.d. washington': ['9th Cir.', 'W.D. Wash.', 'Bankr. W.D. Wash.', 'B.A.P. 9th Cir.'],
  'n.d. west virginia': ['4th Cir.', 'N.D.W. Va.', 'Bankr. N.D.W. Va.'],
  's.d. west virginia': ['4th Cir.', 'S.D.W. Va.', 'Bankr. S.D.W. Va.'],
  'e.d. wisconsin': ['7th Cir.', 'E.D. Wis.', 'Bankr. E.D. Wis.'],
  'w.d. wisconsin': ['7th Cir.', 'W.D. Wis.', 'Bankr. W.D. Wis.'],
  'd. wyoming': ['10th Cir.', 'D. Wyo.', 'Bankr. D. Wyo.', 'B.A.P. 10th Cir.'],
}

const FEDERAL_DISTRICT_PREFIX_LABELS: Record<string, string> = {
  'c.d.': 'central district of',
  'e.d.': 'eastern district of',
  'm.d.': 'middle district of',
  'n.d.': 'northern district of',
  's.d.': 'southern district of',
  'w.d.': 'western district of',
  'd.': 'district of',
}

function titleCaseJurisdictionName(value: string): string {
  return value
    .split(/\s+/)
    .map((word, index) => (index > 0 && word === 'of' ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(' ')
}

function getFederalDistrictLabelFromKey(districtKey: string): string {
  for (const [prefix, labelPrefix] of Object.entries(FEDERAL_DISTRICT_PREFIX_LABELS)) {
    const prefixWithSpace = `${prefix} `
    if (!districtKey.startsWith(prefixWithSpace)) continue

    const districtName = districtKey.slice(prefixWithSpace.length)
    if (prefix === 'd.' && districtName === 'district of columbia') {
      return titleCaseJurisdictionName(districtName)
    }

    return `${titleCaseJurisdictionName(labelPrefix)} ${titleCaseJurisdictionName(districtName)}`
  }

  return titleCaseJurisdictionName(districtKey)
}

export const STATE_LABELS: Record<string, string> = Object.fromEntries(
  Object.keys(STATE_TO_STATE_COURT_MAP).map((state) => [state, titleCaseJurisdictionName(state)])
)

export const FEDERAL_DISTRICT_LABELS: Record<string, string> = Object.fromEntries(
  Object.keys(FEDERAL_DISTRICT_TO_COURTS_MAP).map((districtKey) => [districtKey, getFederalDistrictLabelFromKey(districtKey)])
)

export function getJurisdictionLabel(jurisdiction: string): string {
  return STATE_LABELS[jurisdiction] || FEDERAL_DISTRICT_LABELS[jurisdiction] || jurisdiction
}

/**
 * Retrieves federal court IDs based on the provided state name.
 *
 * @param state - The name of the state.
 * @returns A list of federal court IDs.
 */
export function getFederalCourtIdsByState(state: string): string[] {
  const districtKeys = FEDERAL_DISTRICT_KEYS_BY_STATE[state] ?? []
  return districtKeys.reduce<string[]>((acc, courtId) => {
    acc.push(...(FEDERAL_DISTRICT_TO_COURTS_MAP[courtId] || []))
    return acc
  }, [])
}

const STANDARD_FEDERAL_COURTS = ['U.S.', 'Fed. Cl.', 'C.C.P.A.', "Ct. Int'l Trade", 'U.S.T.C.', 'B.T.A.', 'Fed. Cir.']

const FEDERAL_LRR_SOURCES = [
  'code-of-federal-regulations',
  'constitution-of-united-states',
  'united-states-code',
  'united-states-code.federal-rules-of-appellate-procedure',
  'united-states-code.federal-rules-of-bankruptcy-procedure',
  'united-states-code.federal-rules-of-civil-procedure',
  'united-states-code.federal-rules-of-criminal-procedure',
  'united-states-code.federal-rules-of-evidence',
]

const FEDERAL_COURT_CODES_SET = new Set([...STANDARD_FEDERAL_COURTS, ...Object.values(FEDERAL_DISTRICT_TO_COURTS_MAP).flat()])

/**
 * Retrieves standard federal court IDs (ones applicable to any state).
 *
 * @returns A list of standard federal court IDs.
 */
export function getStandardFederalCourtIds(): string[] {
  return STANDARD_FEDERAL_COURTS
}

/**
 * Retrieves standard federal LRR sources (ones which accompany any federal court and are applicable to any state).
 *
 * @returns A list of standard federal LRR sources.
 */
export function getStandardFederalLRRSources(): string[] {
  return FEDERAL_LRR_SOURCES
}

/**
 * Infers the state selected based on a list of state court IDs.
 *
 * @param stateCourtIds - An array of court IDs.
 * @returns The name of the state or null if not found.
 */
export function inferSelectedStateFromCourtIds(stateCourtIds: string[] | null): string | null {
  if (!stateCourtIds) return null
  for (const state in STATE_TO_STATE_COURT_MAP) {
    if (stateCourtIds.some((courtId) => STATE_TO_STATE_COURT_MAP[state].includes(courtId))) {
      return state
    }
  }
  return null
}

/**
 * Infers all selected states based on a list of state court IDs.
 *
 * @param stateCourtIds - An array of court IDs.
 * @returns An array of matching state names (may be empty).
 */
export function inferSelectedStatesFromCourtIds(stateCourtIds: string[] | null): string[] {
  if (!stateCourtIds || stateCourtIds.length === 0) return []
  const matchedStates: string[] = []
  for (const state in STATE_TO_STATE_COURT_MAP) {
    if (stateCourtIds.some((courtId) => STATE_TO_STATE_COURT_MAP[state].includes(courtId))) {
      matchedStates.push(state)
    }
  }
  return matchedStates
}

/**
 * Determines if a jurisdiction code is a federal court code.
 * Federal court codes include circuit courts, district courts, bankruptcy courts, and bankruptcy appellate panels.
 * Uses the district and standard federal court mappings - no string pattern matching.
 *
 * @param code - The jurisdiction code to check.
 * @returns True if the code represents a federal court, false otherwise.
 */
export function isFederalCourtCode(code: string): boolean {
  return FEDERAL_COURT_CODES_SET.has(code)
}

/**
 * Gets federal content related to a state, separated into courts and LRR sources.
 * Includes state-specific federal courts, standard federal courts, and federal LRR sources.
 *
 * @param stateName - The name of the state.
 * @returns Object containing arrays of courts and lrrSources.
 */
export function getRelatedFederalContent(stateName: string): {
  courts: string[]
  lrrSources: string[]
} {
  return {
    courts: [...getFederalCourtIdsByState(stateName), ...STANDARD_FEDERAL_COURTS],
    lrrSources: FEDERAL_LRR_SOURCES,
  }
}

export function getStateLrrSources(state: string | null): string[] {
  if (!state) return []
  return STATE_LRR_SOURCES_MAP[state.toLowerCase()] || []
}

export function getStateCaselawSources(state: string | null): string[] {
  if (!state) return []
  return STATE_TO_STATE_COURT_MAP[state.toLowerCase()] || []
}

/**
 * Determines if a jurisdiction code is a state LRR source for the given state
 * Used for API payload categorization: lrr_search_filters = STATE_LRR_SOURCES + FEDERAL_LRR_SOURCES
 *
 * @param code - The jurisdiction code to check
 * @param stateName - The selected state name
 * @returns true if the code is a state LRR source for this state
 */
export function isStateLrrSource(code: string, stateName: string | null): boolean {
  return getStateLrrSources(stateName).includes(code)
}

/**
 * Determines if a jurisdiction code is a state caselaw source for the given state
 * Used for API payload categorization: caselaw_search_filters = STATE_CASELAW_SOURCES + FEDERAL_CASELAW_SOURCES
 *
 * @param code - The jurisdiction code to check
 * @param stateName - The selected state name
 * @returns true if the code is a state caselaw source for this state
 */
export function isStateCaselawSource(code: string, stateName: string | null): boolean {
  return getStateCaselawSources(stateName).includes(code)
}

/**
 * Determines if a code is from "Include related federal content" for a given state
 * These are the codes that should be tracked in relatedFederal*Sources arrays
 * to enable proper toggle behavior (preserving manual selections)
 *
 * @param code - The jurisdiction code to check
 * @param stateName - The selected state name
 * @returns Object indicating if code is related federal LRR or caselaw
 */
export function isRelatedFederalContent(code: string, stateName: string | null): { isRelatedLrr: boolean; isRelatedCaselaw: boolean } {
  if (!stateName) return { isRelatedLrr: false, isRelatedCaselaw: false }

  const { courts, lrrSources } = getRelatedFederalContent(stateName)

  return {
    isRelatedLrr: lrrSources.includes(code),
    isRelatedCaselaw: courts.includes(code),
  }
}

export type ResearchSourcesFromJurisdiction = {
  selectedStateNames: string[]
  stateLrrSources: string[]
  stateCaselawSources: string[]
  federalLrrSources: string[]
  federalCaselawSources: string[]
}

/**
 * Infers whether a stored jurisdiction value is a state or federal district key.
 */
export function inferJurisdictionKind(jurisdiction: string | null | undefined): 'state' | 'federal' | null {
  if (!jurisdiction) return null
  if (Object.prototype.hasOwnProperty.call(STATE_TO_STATE_COURT_MAP, jurisdiction)) return 'state'
  if (Object.prototype.hasOwnProperty.call(FEDERAL_DISTRICT_TO_COURTS_MAP, jurisdiction)) return 'federal'
  return null
}

/**
 * Builds research filter buckets for chat prefill from a matter jurisdiction value.
 * State jurisdictions select state sources only. Federal districts select district courts + U.S. + federal LRR.
 */
export function getResearchSourcesForJurisdiction(jurisdiction: string): ResearchSourcesFromJurisdiction {
  const kind = inferJurisdictionKind(jurisdiction)

  if (kind === 'state') {
    return {
      selectedStateNames: [jurisdiction],
      stateLrrSources: STATE_LRR_SOURCES_MAP[jurisdiction] || [],
      stateCaselawSources: STATE_TO_STATE_COURT_MAP[jurisdiction] || [],
      federalLrrSources: [],
      federalCaselawSources: [],
    }
  }

  if (kind === 'federal') {
    const districtCourts = FEDERAL_DISTRICT_TO_COURTS_MAP[jurisdiction] || []
    return {
      selectedStateNames: [],
      stateLrrSources: [],
      stateCaselawSources: [],
      federalLrrSources: [],
      federalCaselawSources: Array.from(new Set(['U.S.', ...districtCourts])),
    }
  }

  return {
    selectedStateNames: [],
    stateLrrSources: [],
    stateCaselawSources: [],
    federalLrrSources: [],
    federalCaselawSources: [],
  }
}
